import React, { useEffect, useRef, useState } from 'react';
const TrailbossFooter = (props) => {

    return (<>
        <div className="footer-area">
            <div className="row">
                <div className="col-md-12">
                    <div className="footer-section section pt-0 pt-3" data-bg-color="#122e14" style={{ backgroundColor: '#014022' }}>
                        <div className="container">
                            <div className="row mb-2">
                                <div className="col-md-2 col-12 d-flex justify-content-center">
                                    <div className="footer-widget">
                                        <div className="logoFooter">
                                            <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} className="logoDashboard" alt="logo" />
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-5 col-12 pl-lg-5">
                                    <div className="footer-widget">
                                        <div className="col-md-12 pl-0">
                                            <h4 className="footer-widget-title">Address</h4></div>
                                        <div className="footer-widget-content">
                                            <div className="content">
                                                <div>2470 Saint Rose Pkwy, Suite 314 Henderson, NV 89074
                                                </div>
                                                <div>201 E. 3rd Avenue Anchorage, AK 99501
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5 col-12 pl-lg-5">
                                    <div className="footer-widget">
                                        <div className="col-md-12">
                                            <h4 className="footer-widget-title"><br /></h4></div>
                                        <div className="footer-widget-content">
                                            <div className="content">
                                                <div>Phone: 907-338-8243<br />
                                                    Fax: 907-338-0869<br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-center align-items-center copyright">
                                    © {new Date().getFullYear()}  Trailboss Enterprises, Inc.  All rights reserved
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </>)
}

export default TrailbossFooter;